import { PLATFORM_ID } from '@angular/core';
import { HttpHandler, HttpRequest, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { isPlatformServer } from '@angular/common';
import * as i0 from "@angular/core";
// this interceptor will transform HttpErrorResponse<Blob> to HttpErrorResponse<Json>.
// used for returning files where you expect a blob but json when the request fails.
// see also https://github.com/angular/angular/issues/19888
export let BlobErrorInterceptor = /*#__PURE__*/(() => {
  class BlobErrorInterceptor {
    constructor(ngPlatformId) {
      this.ngPlatformId = ngPlatformId;
    }
    intercept(req, next) {
      return next.handle(req).pipe(catchError(err => {
        if (isPlatformServer(this.ngPlatformId)) {
          return throwError(() => err);
        } else {
          if (err instanceof HttpErrorResponse && err.error instanceof Blob && err.error.type.includes("application/json")) {
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = e => {
                try {
                  const errmsg = JSON.parse(e.target.result);
                  const newErr = new HttpErrorResponse({
                    error: errmsg,
                    headers: err.headers,
                    status: err.status,
                    statusText: err.statusText,
                    url: err.url
                  });
                  reject(newErr);
                } catch (localErr) {
                  reject(err);
                }
              };
              reader.onerror = e => reject(err);
              reader.readAsText(err.error);
            });
          }
          return throwError(() => err);
        }
      }));
    }
    static {
      this.ɵfac = function BlobErrorInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || BlobErrorInterceptor)(i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: BlobErrorInterceptor,
        factory: BlobErrorInterceptor.ɵfac
      });
    }
  }
  return BlobErrorInterceptor;
})();